import React, { useContext, useMemo } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { aggregateData } from '../functions';
import GraphTable from '../mechanisms/graphtable';
import { formatCurrency } from '../functions';
import { currencyPrefix } from '../single-card';
import { DashboardContext } from '../mechanisms/card';
import DashView from '../mechanisms/dashview';
import { convert_seconds } from '../../Dash/HistoricDash/graphs/charts';
import { defaultOptions } from '../mechanisms/dashview';

const CommunicationSalesDashboard = ({ data }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => {
        const agg_data = aggregateData('duration', data, 'agent')
        agg_data.forEach(row => {
        row.duration = row.duration/(row.count || 1)
        row.owner_name = row.agent_name
    })  
        return agg_data
    }, [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'agent_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'duration', headerName: 'Duração média', flex: 1,
                    renderCell: ({ value }) => convert_seconds(value)
                }
            ]} />
                : <DashView name='communicationsales' rows={graph} vx={'agent_name'} vy={['duration', 'count']} renderValue={(vy, row) => {
                    if (vy === 'duration')
                        return convert_seconds(row[vy])
                    return row[vy]
                }} />
            }
        </>
    );
}


export default CommunicationSalesDashboard